import React from 'react';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'reactstrap';
import { callApi, formatDate } from '../../utils';
import { showError, showInfo } from '../../actions/notificationActions';
import DataTable from '../DataTable';

class MerchantReferral extends React.Component {
  state = {
    queryParams: {
      page: 1,
      limit: '50',
    },
    pages: 1,
    meta: { pages: 1 },
    loading: false,
    rows: [],
  };

  setPage = (page) => {
    if (page) {
      this.setState(
        { queryParams: { ...this.state.queryParams, page } },
        () => {
          this.loadTimeline();
        }
      );
    }
  };

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  loadTimeline = (e) => {
    if (e) e.preventDefault();
    const { page, limit } = this.state.queryParams;
    const id = this.props.id;
    this.setState({ loading: true });
    callApi(`/merchants/${id}/referral`, {
      offset: (page - 1) * limit,
      limit,
    })
      .then(({ data = [], meta }) => {
        this.setState({ loading: false });
        this.setState({ rows: data, meta });
      })
      .catch((err) => {
        this.setState({ loading: false });
        this.props.dispatch(showError(err));
      });
  };

  activeReferral = (referral_id) => {
    const id = this.props.id;
    callApi(
      `/merchants/${id}/referral`,
      {
        referral_id,
      },
      'PUT'
    )
      .then((response) => {
        this.props.dispatch(showInfo('Referral activated successfully'));
        this.loadTimeline();
      })
      .catch((err) => {
        this.props.dispatch(showError(err));
      });
  };

  componentDidMount() {
    this.loadTimeline();
  }

  render() {
    const { rows, queryParams, loading, meta } = this.state;
    return (
      <Row>
        <Col md="12" xs={12}>
          <div className="mt-10">
            <DataTable
              card={false}
              loading={loading}
              minWidth={700}
              page={queryParams.page}
              total={meta.pages}
              onPageChange={this.setPage}
            >
              <thead className="text-primary">
                <tr>
                  <th>S/N</th>
                  <th>Referree Phone</th>
                  <th>Referree Name</th>
                  <th>Referred Account Type</th>
                  <th>Invitation Date</th>
                  <th>Referral Status</th>
                  <th>Activation Date</th>
                  <th>Operation</th>
                </tr>
              </thead>

              <tbody>
                {rows && rows.length > 0 ? (
                  rows.map((MR, i) => (
                    <tr key={MR.id}>
                      <td>
                        {(queryParams.page - 1) * queryParams.limit + (i + 1)}
                      </td>
                      <td>{MR.referee.name}</td>
                      <td>{MR.referee.phone}</td>
                      <td>
                        {MR.referee.role_id !== 11 &&
                        MR.referee.role_id !== 111 &&
                        MR.referee.role_id !== 1
                          ? 'NOT A MERCHANT'
                          : 'MERCHANT'}
                      </td>
                      <td>{formatDate(MR.created_at)}</td>
                      <td>{MR.status}</td>
                      <td>
                        {MR.activated_date
                          ? formatDate(MR.activated_date)
                          : 'null'}
                      </td>
                      <td>
                        <Button
                          disabled={['INACTIVE', 'ACTIVE'].includes(MR.status)}
                          size="sm"
                          onClick={() => {
                            this.activeReferral(MR.id);
                          }}
                        >
                          Activate Referral
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>NO REFERRAL</td>
                  </tr>
                )}
              </tbody>
            </DataTable>
          </div>
        </Col>
      </Row>
    );
  }
}

export default connect()(MerchantReferral);
